import { useState } from "react";

import { useLocalization } from "@/localization/LocalizationContext";

export default function LanguageSwitcher() {
  const { locale, localeNativeName, saving, setLocale, supportedLocales, t } = useLocalization();
  const [error, setError] = useState(false);

  const selectLocale = async (next) => {
    setError(false);
    try { await setLocale(next); } catch { setError(true); }
  };

  return (
    <div className="px-3 py-2" data-testid="language-switcher">
      <div className="mb-1.5 text-[10px] tracking-[0.08em] text-[#8B6F4B]">
        {t("language.selector.label")}
      </div>
      <div className="flex gap-1" role="group" aria-label={t("language.selector.label")}>
        {supportedLocales.map((item) => (
          <button
            type="button"
            key={item}
            onClick={() => selectLocale(item)}
            disabled={saving}
            aria-pressed={locale === item}
            className="rounded-lg px-2 py-1 text-[11px] transition disabled:opacity-50"
            style={{
              background: locale === item ? "#F1E7D7" : "transparent",
              color: locale === item ? "#2A1D14" : "#7A6A55",
            }}
            data-testid={`language-option-${item}`}
          >
            {localeNativeName(item)}
          </button>
        ))}
      </div>
      {error && <div className="mt-1 text-[10px] text-[#9B3A2E]" role="alert">{t("language.selector.saveError")}</div>}
    </div>
  );
}
